export default Object.freeze({
  AUTHORIZATION: '8:ScKVxPPIVNL1C6woOOFm3vWD6BcGu6qwuqM8ICDL',
  BEARER: 'Bearer ',
  CLIENT_BOOKING_EXCLUSION_PERIOD: 0,
  EXTERNAL_CLIENT_ID: 1,
  DATE_OF_BIRTH_MIN_AGE: 16,
  DATE_OF_BIRTH_MIN_YEAR: 100,
  FIREBASEAPIKEY: 'AIzaSyBNxKNGj-M8kTB8jf94tC6AqbgMdj9GnXU',
  FIREBASEAPPID: '1:643036066448:web:b113c01605faac7ea71e15',
  FIREBASEMESSAGINGSENDERID: '643036066448',
  FIREBASEPROJECTID: 'go-do-client-p',
  FIREBASEPUBLICVAPIDKEY: 'BGwYy04UPsUSl36ClhGAToO_swih4eAQRBIO0C81Sid2rfy3L2otJ2z1M_jTkU9fa5cP7cczrdQeU6dl3zspVEc',
  GOOGLEMAPS: 'AIzaSyA9O5iT3CyuB9Wq_pJW22tF92UC3XLXlgE',
  MODE_EDIT: 'edit',
  MODE_VIEW: 'view',
  OPERATOR: 3,
  OPERATOR_DWFF: 2,
  OPERATOR_GODO: 3,
  OPERATOR_PUREGYM: 11,
  OPERATOR_STAR: 1,
  SEARCH_BY_GYM: 'SEARCH_BY_GYM',
  SEARCH_BY_GYM_ONLINE: 'SEARCH_BY_GYM_ONLINE',
  SEARCH_BY_LOCATION: 'SEARCH_BY_LOCATION',
  STATUS_ACCEPTED: 'Accepted',
  STATUS_AVAILABLE: 'Available',
  STATUS_CANCELLED: 'Cancelled',
  STATUS_COMPLETED: 'Completed',
  STATUS_REDEEMED: 'Redeemed',
  STATUS_REJECTED: 'Rejected',
  STATUS_REQUESTED: 'Requested',
  STATUS_UNCOMPLETED_CLIENT: 'Uncompleted/Client',
  STATUS_UNCOMPLETED_PROFESSIONAL: 'Uncompleted/Professional',
  STATUS_UNVERIFIED: 0,
  STATUS_VERIFIED: 1,
  TITLE: 'Go:Do',
  TITLE_BRAND: 'Go:Do',
  TYPE_QUALIFICATION: 'qualification',
  URL: 'https://godo.fitness/api/beta',
  URLV1: 'https://godo.fitness/api/v1',
  USER_TYPE: 'client',
  USER_TYPE_CLIENT: 'client',
  USER_TYPE_PROFESSIONAL: 'professional',
  VERSION: process.env.VERSION,
  VAPID: '',
  WORLDPAY: 'L_C_fde86e23-85ed-4ce1-92dc-ae4fdd447aa0',
  ZOOM_REDIRECT_URI: ''
})
